<template>
    <div>
        <v-rating
                style="display: inline"
                v-model="rate.average"
                background-color="yellow accent-4"
                color="yellow accent-4" readonly
                dense half-increments hover small
        ></v-rating>
        <span v-if="rate.total > 0" class="grey--text text--lighten-2 caption mr-2">
            ({{rate.average}}/{{rate.total}})
        </span>
        <span v-else class="grey--text text--lighten-2 caption mr-2">
            no ratings
        </span>
    </div>
</template>

<script>
    export default {
        name: "Rate",
        props: {
            rate: {
                type: Object,
                default: {}
            }
        },
        watch: {
            rate: {
                handler(val) {
                    val.average = Math.round(val.average * 10) / 10;
                }, deep: true
            }
        }
    }
</script>

<style scoped>

</style>